/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Message_SentInputs */

const en_message_sent = /** @type {(inputs: Message_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message Sent!`)
};

const es_message_sent = /** @type {(inputs: Message_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Mensaje enviado!`)
};

const fr_message_sent = /** @type {(inputs: Message_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message envoyé !`)
};

const de_message_sent = /** @type {(inputs: Message_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht gesendet!`)
};

const ja_message_sent = /** @type {(inputs: Message_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メッセージが送信されました！`)
};

const zh_message_sent = /** @type {(inputs: Message_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消息已发送！`)
};

const ar_message_sent = /** @type {(inputs: Message_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم إرسال الرسالة!`)
};

const id_message_sent = /** @type {(inputs: Message_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan Terkirim!`)
};

const it_message_sent = /** @type {(inputs: Message_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messaggio Inviato!`)
};

const ru_message_sent = /** @type {(inputs: Message_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сообщение отправлено!`)
};

const pt_message_sent = /** @type {(inputs: Message_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensagem Enviada!`)
};

const ko_message_sent = /** @type {(inputs: Message_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메시지가 전송되었습니다!`)
};

/**
* | output |
* | --- |
* | "Message Sent!" |
*
* @param {Message_SentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const message_sent = /** @type {((inputs?: Message_SentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Message_SentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_message_sent(inputs)
	if (locale === "es") return es_message_sent(inputs)
	if (locale === "fr") return fr_message_sent(inputs)
	if (locale === "de") return de_message_sent(inputs)
	if (locale === "ja") return ja_message_sent(inputs)
	if (locale === "zh") return zh_message_sent(inputs)
	if (locale === "ar") return ar_message_sent(inputs)
	if (locale === "id") return id_message_sent(inputs)
	if (locale === "it") return it_message_sent(inputs)
	if (locale === "ru") return ru_message_sent(inputs)
	if (locale === "pt") return pt_message_sent(inputs)
	return ko_message_sent(inputs)
});